import { useState } from "react";
import { LoaderCircle, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const ReplyBox = ({ onSend }) => {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      await onSend(text.trim());
      setText("");
    } catch {
      /* caller already showed the error */
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-2 rounded-2xl border border-slate-200 bg-white p-4" data-testid="reply-form">
      <label htmlFor="reply" className="text-sm font-semibold text-slate-800">Balas tanggapan pengurus RT</label>
      <Textarea id="reply" rows={3} maxLength={3000} value={text} onChange={(e) => setText(e.target.value)} placeholder="Tulis balasan atau informasi tambahan..." className="rounded-xl border-slate-200 text-sm focus-visible:ring-2 focus-visible:ring-emerald-500/30" data-testid="reply-input" />
      <div className="flex justify-end">
        <Button type="submit" disabled={sending || !text.trim()} className="rounded-xl bg-emerald-600 hover:bg-emerald-700" data-testid="reply-submit-btn">
          {sending ? <LoaderCircle className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Kirim Balasan
        </Button>
      </div>
    </form>
  );
};
